export default "__VITE_ASSET__DwUaEWtL__"